import React, { Component, Fragment } from "react";
import Header from "../Header";
import DeleteModal from "./DeleteModal";
import AppContext from "../../../contexts/AppContext";
import {
    updateProfileData,
    updatePassWord as userDetailsUpdatePass,
    records
} from "../../../services/userDatails";

export class AccountSettings extends Component {
    state = {
        first_name: "",
        last_name: "",
        name: "",
        email: "",
        current_password: "",
        new_password: "",
        confirm_password: "",
        profile_URL: this.context.state.user.url,
        email_notification: true,
        public_profile: true,
        showDeleteModal: false
    };
    componentDidMount() {
        if (this.context.state.user.change_profile_flag === "false") {
            this.context.state.urlUpdatedOnce();
        }
        records()
            .then(res => {
                const {
                    first_name,
                    last_name,
                    name,
                    email,
                    link,
                    email_notification,
                    public: public_profile
                } = res.data;
                this.setState({
                    first_name,
                    last_name,
                    name,
                    email,
                    profile_URL: link,
                    email_notification,
                    public_profile
                });
            })
            .catch(err => {
                this.context.state.handelError(err);
            });
    }
    updateProfileURL = () => {
        if (
            this.context.state.user.change_profile_flag === "true" &&
            this.context.state.isUrlUpdatedOnce === false
        ) {
            updateProfileData({
                key: "url",
                value: this.state.profile_URL
            })
                .then(res => {
                    this.context.state.updateUser(res.data);
                    this.context.state.urlUpdatedOnce();
                    this.context.state.showCodeMessage(
                        "Your profile URL has been updated!",
                        "success"
                    );
                })
                .catch(error => {
                    this.context.state.showCodeMessage(
                        "Something went wrong, please try again!",
                        "error"
                    );
                });
        }
    };
    updateEmailNotification = () => {
        setTimeout(() => {
            updateProfileData({
                key: "email_notification",
                value: this.state.email_notification
            })
                .then(res => {
                    this.context.state.showCodeMessage(
                        "Your email notifications status has been updated!",
                        "success"
                    );
                })
                .catch(error => {
                    this.context.state.showCodeMessage(
                        "Something went wrong!",
                        "error"
                    );
                });
        });
    };
    updatePublicProfile = () => {
        setTimeout(() => {
            updateProfileData({
                key: "public",
                value: this.state.public_profile
            })
                .then(res => {
                    this.context.state.showCodeMessage(
                        "Your profile status has been updated!",
                        "success"
                    );
                })
                .catch(error => {
                    this.context.state.showCodeMessage(
                        "Something went wrong!",
                        "error"
                    );
                });
        });
    };
    updateEmail = () => {
        updateProfileData({
            key: "email",
            value: this.state.email
        })
            .then(res => {
                this.context.state.updateUser(res.data);
                this.context.state.showCodeMessage(
                    "Your email has been updated!",
                    "success"
                );
            })
            .catch(error => {
                this.context.state.showCodeMessage(
                    "Please Write a valid email!",
                    "error"
                );
            });
    };
    updateFirstAndLastName = e => {
        if (e.target.value !== "") {
            updateProfileData({
                key: e.target.id,
                value: e.target.value
            })
                .then(res => {
                    this.context.state.updateUser(res.data);
                    this.context.state.showCodeMessage(
                        `Your name has been updated!`,
                        "success"
                    );
                })
                .catch(error => {
                    this.context.state.showCodeMessage(
                        "Something went wrong !",
                        "error"
                    );
                });
        }
    };
    updateCompanyName = e => {
        if (e.target.value !== "") {
            updateProfileData({
                key: e.target.id,
                value: e.target.value
            })
                .then(res => {
                    this.context.state.updateUser(res.data);
                    this.context.state.showCodeMessage(
                        `Your company name has been updated!`,
                        "success"
                    );
                })
                .catch(error => {
                    this.context.state.showCodeMessage(
                        "Something went wrong !",
                        "error"
                    );
                });
        }
    };
    userDetailsUpdatePass = e => {
        if (this.state.new_password === this.state.confirm_password) {
            userDetailsUpdatePass({
                old_password: this.state.current_password,
                password: this.state.new_password,
                password_confirmation: this.state.confirm_password
            })
                .then(res => {
                    this.context.state.updateUser(res.data);
                    this.context.state.showCodeMessage(
                        `Your password has been updated!`,
                        "success"
                    );
                })
                .catch(error => {
                    this.context.state.showCodeMessage(
                        "Something went wrong !",
                        "error"
                    );
                });
        }
    };
    handleInputChange = e => {
        this.setState({ [e.target.id]: e.target.value });
    };
    handleCheckBoxChange = e => {
        const toggled = this.state[e.target.id] === "true" ? "false" : "true";
        this.setState({ [e.target.id]: toggled });
    };
    toggleDeleteModal = () => {
        this.setState({ showDeleteModal: !this.state.showDeleteModal });
    };

    render() {
        return (
            <Fragment>
                {/* <Header></Header> */}
                <div className="main-content pt-0">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-12 col-xl-12">
                                <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h1 className="header-title">
                                                   My Account
                                                </h1>
                                                <h6 className="header-pretitle">
                                                    Manage your account
                                                    settings.
                                                </h6>
                                            </div>
                                            <div className="col-auto"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="first_name">
                                                First name
                                            </label>

                                            <input
                                                value={this.state.first_name}
                                                onChange={
                                                    this.handleInputChange
                                                }
                                                onBlur={
                                                    this.updateFirstAndLastName
                                                }
                                                id="first_name"
                                                name="first name"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="last_name">
                                                Last name
                                            </label>

                                            <input
                                                onBlur={
                                                    this.updateFirstAndLastName
                                                }
                                                value={this.state.last_name}
                                                onChange={
                                                    this.handleInputChange
                                                }
                                                name="last name"
                                                id="last_name"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr className="mt-4 mb-5 " />
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="name">
                                                Company Name
                                            </label>

                                            <input
                                                value={this.state.name}
                                                onChange={
                                                    this.handleInputChange
                                                }
                                                onBlur={
                                                    this.updateCompanyName
                                                }
                                                id="name"
                                                name="name"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr className="mt-4 mb-5 " />
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="row">
                                            <div className="col-12 col-md-12">
                                                <div className="form-group m-form__group">
                                                    <label
                                                        className="mb-1"
                                                        htmlFor="email"
                                                    >
                                                        Email
                                                    </label>
                                                    <input
                                                        onChange={
                                                            this
                                                                .handleInputChange
                                                        }
                                                        value={this.state.email}
                                                        id="email"
                                                        type="email"
                                                        className="form-control"
                                                    />
                                                </div>
                                                <button
                                                    onClick={this.updateEmail}
                                                    id="emailButton"
                                                    type="button"
                                                    className="btn btn-primary"
                                                >
                                                    Update email
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <label className="mb-1">
                                                Change email
                                            </label>
                                            <small className="form-text text-muted">
                                                <strong> Please note </strong>:
                                                We’ll use this email to send you
                                                updates and notifications
                                                regarding your ProWriter
                                                account. Updating this email
                                                will only change where you
                                                receive these notifications, not
                                                which notifications you receive.
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <hr className="mt-4 mb-5 " />
                                <div className="row mb-5">
                                    <div
                                        id="passwordForm"
                                        className="col-12 col-md-6"
                                    >
                                        <form>
                                            <div className="form-group m-form__group">
                                                <label htmlFor="current_password">
                                                    Current password
                                                </label>
                                                <input
                                                    onChange={
                                                        this.handleInputChange
                                                    }
                                                    type="password"
                                                    id="current_password"
                                                    className="form-control m-input m-input--square"
                                                />
                                            </div>
                                            <div className="form-group m-form__group">
                                                <label htmlFor="new_password">
                                                    New password
                                                </label>
                                                <input
                                                    onChange={
                                                        this.handleInputChange
                                                    }
                                                    type="password"
                                                    id="new_password"
                                                    className="form-control m-input m-input--square"
                                                />
                                            </div>
                                            <div className="form-group m-form__group">
                                                <label htmlFor="confirm_password">
                                                    Confirm password
                                                </label>
                                                <input
                                                    onChange={
                                                        this.handleInputChange
                                                    }
                                                    type="password"
                                                    id="confirm_password"
                                                    className="form-control m-input m-input--square"
                                                />
                                            </div>
                                            <button
                                                type="button"
                                                onClick={
                                                    this.userDetailsUpdatePass
                                                }
                                                className="btn btn-primary"
                                            >
                                                Update password
                                            </button>
                                        </form>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <label className="mb-1">
                                                Password requirements
                                            </label>
                                            <small className="form-text text-muted">
                                                A strong password should include
                                                at least one special character,
                                                capital letter, and number in
                                                it.
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                {/* <hr className="mt-4 mb-5 " /> */}
                                {/* <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="row">
                                            <div className="col-12 col-md-12">
                                                <div className="form-group m-form__group">
                                                    <label
                                                        className="mb-1"
                                                        htmlFor="profile_URL"
                                                    >
                                                        URL
                                                    </label>
                                                    <input
                                                        readOnly={
                                                            this.context.state
                                                                .isUrlUpdatedOnce
                                                        }
                                                        value={
                                                            this.state
                                                                .profile_URL
                                                        }
                                                        onChange={
                                                            this
                                                                .handleInputChange
                                                        }
                                                        id="profile_URL"
                                                        type="text"
                                                        className="form-control"
                                                    />
                                                </div>
                                                <button
                                                    onClick={
                                                        this.updateProfileURL
                                                    }
                                                    disabled={
                                                        this.context.state
                                                            .isUrlUpdatedOnce
                                                    }
                                                    id="profileButton"
                                                    type="button"
                                                    className="btn btn-primary"
                                                >
                                                    Update URL
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <label className="mb-1">
                                                Profile URL
                                            </label>
                                            <small className="form-text text-muted">
                                                <strong> Please Note </strong>:
                                                You are only able to change your
                                                ProWriter username once. Do not
                                                add any unusual capitalization,
                                                punctuation, or characters.
                                            </small>
                                        </div>
                                    </div>
                                </div> */}

                                <hr className="mt-4 mb-5 " />
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group m-form__group">
                                            <label className="mb-1">
                                                Email notifications
                                            </label>
                                            <div className="custom-control custom-switch">
                                                <input
                                                    onClick={
                                                        this
                                                            .updateEmailNotification
                                                    }
                                                    onChange={
                                                        this
                                                            .handleCheckBoxChange
                                                    }
                                                    checked={
                                                        this.state
                                                            .email_notification ===
                                                        "true"
                                                    }
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id="email_notification"
                                                />
                                                <label
                                                    className="custom-control-label"
                                                    htmlFor="email_notification"
                                                ></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <small className="text-muted">
                                            Allows to turn Off and On the
                                            different email notifications" to
                                            "Turning off ProWriter notifications
                                            means you will not be emailed when
                                            there are important account
                                            notifications for your review.
                                        </small>
                                    </div>
                                </div>
                                {/* <hr className="mt-4 mb-5 " /> */}
                                {/* <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <label className="mb-1">
                                                Public profile
                                            </label>
                                            <div className="row">
                                                <div className="col-auto">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            onClick={
                                                                this
                                                                    .updatePublicProfile
                                                            }
                                                            onChange={
                                                                this
                                                                    .handleCheckBoxChange
                                                            }
                                                            checked={
                                                                this.state
                                                                    .public_profile ===
                                                                "true"
                                                            }
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="public_profile"
                                                        />
                                                        <label
                                                            className="custom-control-label"
                                                            htmlFor="public_profile"
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div className="col ml-n2">
                                                    <small className="text-muted">
                                                        You're currently{" "}
                                                        {this.state
                                                            .public_profile
                                                            ? "visible"
                                                            : "invisible"}{" "}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <small className="text-muted">
                                            Making your profile public means
                                            that anyone on the ProWriter network
                                            will be able to find you.
                                        </small>
                                    </div>
                                </div> */}

                                <hr className="mt-4 mb-5" />
                                <div className="row mb-7">
                                    <div className="col-12 col-md-6">
                                        <div className="row">
                                            <div className="col-12 col-md-12">
                                                {this.state.showDeleteModal ? (
                                                    <DeleteModal
                                                        hideDelete={
                                                            this
                                                                .toggleDeleteModal
                                                        }
                                                    ></DeleteModal>
                                                ) : null}
                                                <button
                                                    onClick={
                                                        this.toggleDeleteModal
                                                    }
                                                    type="button"
                                                    className="btn btn-danger"
                                                >
                                                    Delete account
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group">
                                            <label className="mb-1">
                                                Delete account
                                            </label>
                                            <small className="form-text text-muted">
                                                <strong> Please note </strong>:
                                                Deleting your account will
                                                cancel any open Memberships as
                                                well as remove all data from
                                                ProWriter including your writer
                                                portfolio, clients, and messages
                                                history
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
AccountSettings.contextType = AppContext;
export default AccountSettings;



// WEBPACK FOOTER //
// ./src/components/employer/settings/AccountSettings.js